// extracted by mini-css-extract-plugin
export default {"rightSidebarContainer":"RightSidebarComponent_rightSidebarContainer__8SVgD","specificationsWrapper":"RightSidebarComponent_specificationsWrapper__QYGVv"};